function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import QuestionMark from 'svg/question-mark.svg';
import * as actions from '../../../actions';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const ConnectionImage = ({ selectedChannel })=>{
    let imageSrc;
    switch(selectedChannel){
        case 'BuiltInUsb':
            imageSrc = '/assets/svg/disconnect-by-usb.svg';
            break;
        case 'MicroUsb':
            imageSrc = '/assets/svg/disconnect-by-usb-cable.svg';
            break;
        case 'UsbC':
            imageSrc = '/assets/svg/disconnect-by-usb-c-cable.svg';
            break;
        case 'BlueCable':
            imageSrc = '/assets/svg/disconnect-by-blue-cable.svg';
            break;
        case 'Bluetooth':
            imageSrc = '/assets/svg/disconnect-by-bluetooth.svg';
            break;
        default:
            imageSrc = '/assets/svg/connection-failed.svg';
            break;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.illustration,
        children: /*#__PURE__*/ _jsx("img", {
            src: imageSrc,
            className: styles.connectionFailed__img,
            alt: ""
        })
    });
};
const MdaConnectionFailed = ({ selectedChannel, onSetComponent })=>{
    const { formatMessage } = useIntl();
    const clearConnection = useAction(actions.clearConnection);
    const onRetry = ()=>{
        clearConnection();
        onSetComponent('Connect');
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectionFailed.header))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectionFailed.info))
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: styles.connectionFailed__list,
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: styles.connectionFailed__list__item,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.connectionFailed__list__item__content,
                            children: /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectionFailed.steps.first))
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: styles.connectionFailed__list__item,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.connectionFailed__list__item__content,
                            children: /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectionFailed.steps.second)),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "https://support.glucocontro.online/hc",
                                        target: "_blank",
                                        "data-for": "userBoxTooltip",
                                        "data-tip": formatMessage(messages.connectionFailed.questionSteps.second),
                                        "aria-label": formatMessage(messages.connectionFailed.questionSteps.second),
                                        children: /*#__PURE__*/ _jsx(QuestionMark, {
                                            className: styles.connectionFailed__questionMark
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: styles.connectionFailed__list__item,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.connectionFailed__list__item__content,
                            children: /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.connectionFailed.steps.third))
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ConnectionImage, {
                selectedChannel: selectedChannel
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "modal__actions",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.tryAgain,
                    className: "btn--block btn--filled",
                    onClick: onRetry
                })
            }),
            /*#__PURE__*/ _jsx(ReactTooltip, {
                id: "userBoxTooltip",
                place: "right",
                type: "dark",
                effect: "solid"
            })
        ]
    });
};
export default MdaConnectionFailed;
